// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".7158ddcb6e638ce5a99559066b64a9d2.js";
};